// @flow
import gql from 'graphql-tag'

export const HANDBOOK_FIELDS_FRAGMENT = gql`
  fragment HandbookFields on Handbook {
    id
    htmlContent
  }
`

export type Handbook = {
  id: string,
  htmlContent: string,
}
